import { render } from "./vtagslist.vue?vue&type=template&id=ed205d86&scoped=true"
import script from "./vtagslist.vue?vue&type=script&lang=js"
export * from "./vtagslist.vue?vue&type=script&lang=js"

import "./vtagslist.vue?vue&type=style&index=0&id=ed205d86&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed205d86"]])

export default __exports__